module.exports = __webpack_public_path__ + "img/bag.e7d6d4b4.jpeg";